import React, { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";

import fetch from "../../../utils/fetch";

import Input from "../../../components/main/input";
import Button from "../../../components/main/button";
import Title from "../../../components/main/title";

import { useAuthStore } from "../../../store/auth";

interface Props {
    footer: any;
}

const bg: any = [];
const bg_rand = bg[Math.floor(Math.random() * 5)];

const ResetPassword: React.FC<Props> = ({ footer }) => {
    const loggedIn = useAuthStore<any>((s) => s.loggedIn);

    const [password, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [code, setCode] = useState("");
    const [buttonActive, setButtonActive] = useState({ reset: false });

    useEffect(() => {
        const path = window.location.pathname.replace(/\/$/, "").split("/");

        const code = path[2];
        setCode(code);

        if (code.length !== 36) {
            window.location.href = "/";
        } else {
            new fetch(`/auth/check-reset-password?code=${code}`, {}, { success: false, error: false })
                .get()
                .then((res) => {
                    if (res.status !== "success") {
                        window.location.href = "/";
                    }
                })
                .catch(() => {
                    window.location.href = "/";
                });
        }
    }, []);

    if (loggedIn === true) {
        window.location.href = "/dashboard";
        return <></>;
    }

    const reset = () => {
        setButtonActive({ ...buttonActive, reset: true });
        const post = new fetch(
            "/auth/reset-password",
            {
                password: password,
                confirm_password: confirmPassword,
                code: code,
            },
            { success: true, error: true }
        ).post();

        post.then((res) => {
            if (res.status === "success") {
                setTimeout(() => {
                    window.location.href = "/login";
                }, 3000);
            }
            setButtonActive({ ...buttonActive, reset: false });
        }).catch((e) => {
            setButtonActive({ ...buttonActive, reset: false });
        });
    };

    return (
        <>
            <div id="login">
                <div>
                    <div className="auth-header-logo">
                        <span
                            className="logo-title"
                            onClick={() => {
                                window.location.href = "/";
                            }}
                        >
                            YPC VCA
                        </span>
                    </div>
                    <Title title="h2" value="Reset password" />
                    <Input
                        type="password"
                        name="password"
                        placeholder="Password"
                        updateChange={(value) => {
                            setPassword(value);
                        }}
                        onKeyDown={(e) => {
                            if (e.keyCode === 13) {
                                reset();
                            }
                        }}
                    />
                    <Input
                        type="password"
                        name="confirmPassword"
                        placeholder="Confirm password"
                        updateChange={(value) => {
                            setConfirmPassword(value);
                        }}
                        onKeyDown={(e) => {
                            if (e.keyCode === 13) {
                                reset();
                            }
                        }}
                    />
                    <div className="text-right">
                        <Button
                            active={buttonActive.reset}
                            color="blue"
                            value="Reset Password"
                            onClick={() => {
                                reset();
                            }}
                        />
                    </div>
                    {footer}
                </div>
                <div className="position-relative" style={{ backgroundColor: "#155bd5" }}>
                    <div className="auth-bg-msg"></div>
                </div>
            </div>
        </>
    );
};

export default ResetPassword;
